var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Instant, LocalDate } from '@js-joda/core';
import { createDefaultState as createEnumState } from '.';
const _sortDate = (a, b, desc = false) => {
    return desc ? (b !== null && b !== void 0 ? b : LocalDate.MIN).compareTo(a !== null && a !== void 0 ? a : LocalDate.MIN) : (a !== null && a !== void 0 ? a : LocalDate.MAX).compareTo(b !== null && b !== void 0 ? b : LocalDate.MAX);
};
export const sortTimeline = (a, b, newest = true) => {
    return _sortDate(a.start_date, b.start_date, newest);
};
export const createTimeline = (pId, addedBy = '') => ({
    id: null,
    propertyId: pId,
    title: '',
    occurred: '',
    start_date: LocalDate.now(),
    end_date: LocalDate.now().plusDays(1),
    description: '',
    addedBy,
    addedByName: '',
    kind: 'other',
    source: '',
    isFeatured: false,
    shield: false,
    attachments: [],
});
// What a thumbnail cycles through: the parcel's story photos, else the one main photo, else nothing.
export const parcelThumbnails = (assets) => assets.parcelPhotos.length > 0 ? assets.parcelPhotos : assets.thumbnailPhoto ? [assets.thumbnailPhoto] : [];
export const isPropertyCard = (x) => 'title' in x;
export const mapPropertyToMapAttributes = (x) => ({
    'propertyId': x.id,
    'propertyTitle': x.title,
    'parcelId': x.parcel.id,
    'districtId': x.parcel.districtId,
    'created': x.parcel.created,
    'address': x.parcel.address,
    'isProperty': true,
});
export const hasDistrictCommunity = (x) => x.communities.some(c => c.kind === 'district');
export const isViewable = (x) => x.status.name === 'published';
export const emptyProperty = (id, parcelId) => ({
    'id': id,
    'parcelId': parcelId,
    'communities': [],
    'owners': [],
    'title': '',
    'status': createEnumState(),
    'overview': '',
    'ownerDetails': '',
    'established': '',
    'isFeatured': false,
    'created': Instant.now(),
    'updated': Instant.now(),
    'assets': {
        '_raw': [],
        '_raw_attachments': [],
        'photos': [],
        'thumbnailPhoto': null,
        'heroPhoto': null,
        'parcelPhotos': [],
        'headerVariants': [],
        'attachments': [],
    },
    'parcel': {
        'id': parcelId,
        'districtId': null,
        'point': [0, 0],
        'address': '',
        'kind': null,
        'created': Instant.now(),
    },
    'timeline': [],
    'tags': [],
    'residents': [],
    'quickfacts': [],
});
export const emptyPropertyFormCreate = (parcelId) => ({
    parcelId,
    communities: [],
    owners: [],
    title: '',
    status: createEnumState(),
    overview: '',
    ownerDetails: '',
    established: '',
    isFeatured: false,
    attachments: [],
    headerVariants: [],
    parcel: {
        id: parcelId,
        districtId: null,
        point: [0, 0],
        address: '',
        kind: null,
        created: Instant.now(),
    },
    timeline: [],
    tags: [],
    residents: [],
    quickfacts: [],
});
export const propertyFromCreateResult = (res) => res.property ? toPropertyForm(res.property) : Object.assign(Object.assign({}, toPropertyForm()), { parcel: res.parcel, parcelId: res.parcel.id, title: res.parcel.address });
export const toPropertyFormUpdate = (property) => (Object.assign(Object.assign({}, property), { attachments: property.assets.attachments, headerVariants: property.assets.headerVariants, timeline: property.timeline.map((_a) => {
        var { assets } = _a, x = __rest(_a, ["assets"]);
        return (Object.assign(Object.assign({}, x), { propertyId: property.id, occurred: x.occurred || '', shield: false, attachments: assets.photos }));
    }) }));
export const toPropertyForm = (property) => property ? toPropertyFormUpdate(property) : emptyPropertyFormCreate('');
